<template>
  <div style="width:100%;height:100%">
    <h1 class="chart-top-title">药品消费量分析<span class="chart-modal-flag" @click="dialogVisible = true"><i class="el-icon-view"></i></span></h1>
    <div class="chart-wrapper" ref="chart" style="height:364px;width:100%"></div>
    <el-dialog :visible.sync="dialogVisible" :append-to-body="true" :fullscreen="true" center :modal="mask">
      <iframe height="100%" width="100%" src="../../../static/iframe/category.html"></iframe>
    </el-dialog>
  </div>
</template>

<script>
import { vueBus } from '../../assets/js/common/vueBus'
export default {
  name: 'plusMinusLineChart',
  props: {
    echartsData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      dialogVisible: false,
      mask: false,
      fullscreen: true,
      isinit: '',
      anima: '',
      data: [
        [35199.46, 17599.73, 23466.31, 41066.04, 41062.72, 20531.36, 27375.14, 47906.5, 47317.43, 23658.72, 31544.96, 55203.67, 52331.8, 26165.9, 34887.87, 61053.77, 57936.62, 28968.31, 38624.41, 67592.72, 63051.2, 31525.6, 42034.13, 73559.73],
        [-33523.3, -16761.65, -22348.86, -39110.51, -39107.35, -19553.67, -26071.57, -45625.24, -45064.22, -22532.11, -30042.82, -52574.93, -49839.81, -24919.91, -33226.54, -58146.45, -55177.73, -27588.87, -36785.15, -64374.02, -60048.76, -30024.38, -40032.51, -70056.89]
      ],
      data1: [
        [52156.4289318144, 20334.2658826752, 37586.7485733888, 27502.1633961216, 30469.943470464, 25964.776865664, 52860.62149632, 40876.878327552, 53828.329304928, 47763.165439584, 50204.02406832, 79593.18456474, 33118.013667168, 33565.59264808, 52824.88553328, 73829.49911334, 63714.2621538999, 31604.14898487, 65847.81669501, 53304.26310678, 70648.76963078, 50280.02939784, 75468.48343144, 45799.39093994],
        [-42362.271712, -22337.689568, -16515.810496, -30528.548224, -26449.603707, -22538.868807, -35483.401326, -45885.95616, -40783.12272, -26903.341728, -38800.296864, -43727.318688, -66885.029046, -44390.660112, -19803.019032, -35054.00181, -65220.078042, -24885.156681, -41971.860714, -51848.674563, -58387.412918, -37850.736314, -41553.743304, -62370.647464]
      ],
      dataArr: [
        [25199.46, 37599.73, 13466.31, 46066.04, 34062.72, 20531.36, 37375.14, 57906.5, 27317.43, 43658.72, 41544.96, 55203.67, 22331.8, 26165.9, 64887.87, 41053.77, 37936.62, 48968.31, 68624.41, 67592.72, 43051.2, 51525.6, 62034.13, 43559.73],
        [-33523.3, -16761.65, -22348.86, -39110.51, -39107.35, -19553.67, -26071.57, -45625.24, -45064.22, -22532.11, -30042.82, -52574.93, -49839.81, -24919.91, -33226.54, -58146.45, -55177.73, -27588.87, -36785.15, -64374.02, -60048.76, -30024.38, -40032.51, -70056.89]
      ],
      xData: ['2012/03', '2012/06', '2012/09', '2012/12', '2013/03', '2013/06', '2013/09', '2013/12', '2014/03', '2014/06', '2014/09', '2014/12', '2015/03', '2015/06', '2015/09', '2015/12', '2016/03', '2016/06', '2016/09', '2016/12', '2017/03', '2017/06', '2017/09', '2017/12',],
      legendData: ['库存量', '购买量'],
      color: this.$chartColor || ['#08A7DF', '#8ABE32'],
      axisLabelColor: '#ccd6e0',
      axisLineColor: '#809ab1'
    }
  },
  watch: {
    echartsData: {
      handler: function(val, oldVal) {
        this.initChart()
      },
      deep: true //增加deep 观察对象的子对象变化
    },
    anima: {
      handler: function(val, oldVal) {
        if (val == 'animateStart') {
          this.myChart = this.$echarts.init(this.$refs.chart)
          this.initChart()
        }
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      let me = this
      vueBus.$on('imgOnload', v => {
        me.anima = v
      })
    })
  },
  methods: {
    handleClose(done) {
      done();
    },
    initChart() {
      
      let series = [];
      this.dataArr.map((item, index) => {
        let colorItem = '';
        if(index === 0){
          colorItem = new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: '#006497'
                  },
                  {
                    offset: 1,
                    color: '#000'
                  }
                ])
        }else {
          colorItem = new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [
                  {
                    offset: 0,
                    color: '#006497'
                  },
                  {
                    offset: 1,
                    color: '#000'
                  }
                ])
        }
        series.push(
          {
            name: this.legendData[index],
            type: 'line',
            smooth: false,
            symbol: 'none',
            sampling: 'average',
            itemStyle: {
              normal: {
                color: this.color[index]
              }
            },
            areaStyle: {
              normal: {
                color: colorItem
              }
            },
            data: item
          }
        )
      })
      let option = {
        tooltip: {
          trigger: 'axis',
          position: function(pt) {
            return [pt[0], '10%']
          },
          formatter: function(params){
            // console.log(params)
            return params[0].name + '<br/>' + params[0].seriesName + '：' + params[0].value + '<br/>'  + params[1].seriesName + '：' + Math.abs(params[1].value)
          }
        },
        legend: {
          show: true,
          icon: 'rect',
          top: 10,
          left: 'center',
          itemGap: 50,
          textStyle: {
            color: '#fff',
            padding: [0,5],
            fontSize: 30
          },
          data: this.legendData
        },
        xAxis: {
          type: 'category',
          name: '',
          nameTextStyle: {
            color: '#969899',
            fontWeight: 'bold'
          },
          boundaryGap: false,
          data: this.xData,
          axisLabel: {
            show: true,
            textStyle: {
              color: this.axisLabelColor
            }
          },
          axisLine: {
            // symbol: ['none', 'arrow'],
            // symbolOffset: [0, 10],
            lineStyle: {
              width: 2,
              color: this.axisLineColor
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: this.axisLineColor
            }
          }
        },
        yAxis: {
          type: 'value',
          name: '单位：千万',
            nameTextStyle: {
              color: this.axisLabelColor,
              fontSize: 16
            },
          axisLine: {
            // symbol: ['none', 'arrow'],
            lineStyle: {
              width: 3,
              color: this.axisLineColor
            }
          },
          axisLabel: {
              margin: 10,
              textStyle: {
                fontSize: 14
              },
              color: this.axisLabelColor,
              formatter: function(params){
                  if(params < 0){
                    return Math.abs(params)
                  }else return params
              }
            },
          axisTick: {
            show: false
          },
          splitLine: {
            show: false
          }
        },
        grid: {
          top: 70,
          left: 80,
          bottom: 50,
          right: 80
        },
        series: series
      }
      // this.myChart.on('click', params => {
      //   this.$emit('handleCharts', params.name)
      // })
      this.myChart.setOption(option)
      var currentIndex = -1
      let _this = this
      // setInterval(function() {
      //   var dataLen = option.series[0].data.length

      //   // 取消之前高亮的图形
      //   _this.myChart.dispatchAction({
      //     type: 'downplay',
      //     seriesIndex: 0,
      //     dataIndex: currentIndex
      //   })
      //   currentIndex = (currentIndex + 1) % dataLen
      //   // 高亮当前图形
      //   _this.myChart.dispatchAction({
      //     type: 'highlight',
      //     seriesIndex: 0,
      //     dataIndex: currentIndex
      //   })
      //   // 显示 tooltip
      //   _this.myChart.dispatchAction({
      //     type: 'showTip',
      //     seriesIndex: 0,
      //     dataIndex: currentIndex
      //   })
      // }, 1000)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.chart-modal-flag {
  line-height: 64px;
  font-size: 40px;
  font-weight: 700;
  color: #fff;
  right: 25px;
  position: absolute;
  i {
    color: #fff;
    cursor: pointer;
    font-weight: 900;
  }
}

.chart-top-title {
  height: 76px;
  line-height: 95px;
  font-size: 40px;
  font-weight: 700;
  color: #65ecc3;
  text-align: center;
  letter-spacing: 2px;
  position: relative;
  .chart-select {
    position: absolute;
    width: 175px;
    height: 45px;
    line-height: 45px;
    border: 2px solid #046292;
    left: 28px;
    top: 26px;
    border-radius: 8px;
    font-weight: 400;
    color: #fff;
    font-size: 20px;
    text-align: left;
    padding-left: 20px;
    -webkit-border-radius: 8px;
    -moz-border-radius: 8px;
    -ms-border-radius: 8px;
    -o-border-radius: 8px;
  }
  .select-icon {
    position: absolute;
    font-size: 26px;
    right: 10px;
    top: 3px;
  }
 }
 .remarkes {
  height: 40px;
  line-height: 24px;
  font-size: 20px;
  color: #acb4bc;
  padding-left: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/echarts/plusMinusLineChart.vue